/**
 *
 * This file is for one-time configuration (i.e., "settings") for this project.
 * This file should be committed to the repository and should not be modified on each build.
 *
 */



const year = (new Date()).getFullYear();

export const AppConfig = {
  name: 'HamafteachDatabaseWebClient',
  pascalCaseName: 'HamafteachDatabaseWebClient',
  mainWebsiteLink: 'http://firecoding.com',
  year,
};




// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/core/config/app.config.ts